export interface RenderedItem {
  id: string
  title: string
  order: number
  content?: string
  columnId: string
}

export const CONTENT_TYPES = {
  card: 'application/app-card',
  column: 'application/app-column',
}

export const INTENTS = {
  updateColumnName: 'updateColumnName' as const,
  updateBoardName: 'updateBoardName' as const,
}

export const ItemMutationFields = {
  id: { type: String, name: 'id' },
  columnId: { type: String, name: 'columnId' },
  order: { type: Number, name: 'order' },
  title: { type: String, name: 'title' },
} as const

/**
 * Cookie Consent Constants
 *
 * Single source of truth for consent storage key.
 * Used by CookiesBanner and consent hooks for PostHog consent management.
 */

/**
 * LocalStorage key for storing consent status
 * Values: 'pending' | 'granted' | 'denied'
 */
export const CONSENT_STORAGE_KEY = 'posthog_consent_status'

/**
 * Consent status type - matches PostHog's explicit consent status
 */
export type ConsentStatus = 'pending' | 'granted' | 'denied'
